<template>
  <div class="main-chart">
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         style="display: none;">
      <symbol id="wave">
        <path
            d="M420,20c21.5-0.4,38.8-2.5,51.1-4.5c13.4-2.2,26.5-5.2,27.3-5.4C514,6.5,518,4.7,528.5,2.7c7.1-1.3,17.9-2.8,31.5-2.7c0,0,0,0,0,0v20H420z"></path>
        <path
            d="M420,20c-21.5-0.4-38.8-2.5-51.1-4.5c-13.4-2.2-26.5-5.2-27.3-5.4C326,6.5,322,4.7,311.5,2.7C304.3,1.4,293.6-0.1,280,0c0,0,0,0,0,0v20H420z"></path>
        <path
            d="M140,20c21.5-0.4,38.8-2.5,51.1-4.5c13.4-2.2,26.5-5.2,27.3-5.4C234,6.5,238,4.7,248.5,2.7c7.1-1.3,17.9-2.8,31.5-2.7c0,0,0,0,0,0v20H140z"></path>
        <path
            d="M140,20c-21.5-0.4-38.8-2.5-51.1-4.5c-13.4-2.2-26.5-5.2-27.3-5.4C46,6.5,42,4.7,31.5,2.7C24.3,1.4,13.6-0.1,0,0c0,0,0,0,0,0l0,20H140z"></path>
      </symbol>
    </svg>
    <div class="box">
      <div class="percent">
        <p class="number">{{$levels[state.userInfo.userAccountLevel]  + ' ' + 'سطح'}}</p>
        <div class="percentNum" id="count">{{ ctn + '%' }}</div>
      </div>
      <div :style="{transform: `translate(0px, ${100-ctn}%`}" id="water"
           :class="{
             'water-level-1' : level === 1,
             'water-level-2' : level === 2,
             'water-level-3' : level === 3,
             'water-level-4' : level === 4,
             'water-level-5' : level === 5,
             'water-level-6' : level === 6,
             'water-level-7' : level === 7
      }"

      >
        <svg viewBox="0 0 560 20" class="water_wave water_wave_back">
          <use xlink:href="#wave"></use>
        </svg>
        <svg viewBox="0 0 560 20" class="water_wave water_wave_front">
          <use xlink:href="#wave"></use>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "water-fill-chart2",

  data() {
    return {
      ctn: 30,
      level: 1,
    }
  },
  watch:{
    'level'(){
      this.ctn = this.level * 20;
    }
  },
  created() {
    this.level = parseInt(this.$levels[this.state.userInfo.userAccountLevel])
// console.log(this.level)
  },

}
</script>

<style lang="scss" scoped>
#water{
  animation:  mymove 1.5s 1;
}

@keyframes mymove {
  from {top: 100px;}
  to {top: 0;}
}
.water {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  transform: translate(0, 100%);
  transition: all 1.5s;

  &_wave {
    width: 200%;
    position: absolute;
    bottom: 100%;

    &_back {
      right: 0;
      animation: wave-back 1.4s infinite linear;
    }

    &_front {
      left: 0;
      margin-bottom: -1px;
      animation: wave-front .7s infinite linear;
    }
  }
}

.main-chart {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 160px;
  position: relative;
  margin-top: 40px;

}

*, *:before, *:after {
  box-sizing: border-box;
  outline: none;
}

$bgColor: transparent;
$boxColor: rgba(255, 255, 255, 0.04);

body {
  background: $bgColor;
  font: 14px/1 'Open Sans', helvetica, sans-serif;
  -webkit-font-smoothing: antialiased;
}

.box {
  height: 180px !important;
  width: 180px !important;
  position: absolute;
  top: 0;
  transform: translate(0, -30%);
  background: $boxColor;
  border-radius: 100%;
  overflow: hidden;

  .percent {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 3;
    width: 100%;
    height: 100%;
    display: flex;
    display: -webkit-flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 64px;

    .percentNum {
      font-size: clamp(12px, 2vw, 18px);
      color: rgba(215, 200, 200, 1);
    }

    .percentB {
      font-size: 15px;
    }

    p {
      font-size: clamp(12px, 2vw, 18px);
    }
  }


  .water-level-1 {
    @extend .water;
    background: rgba(233, 196, 106, 1);

    .water_wave_front {
      fill: rgba(233, 196, 106, 1);
    }

    .water_wave_back {
      fill: rgba(244, 162, 97, 0.2);
    }
  }

  .water-level-2 {
    @extend .water;
    background: rgba(244, 162, 97, 1);

    .water_wave_front {
      fill: rgba(244, 162, 97, 1);
    }

    .water_wave_back {
      fill: rgba(244, 162, 97, 0.2);
    }
  }

  .water-level-3 {
    @extend .water;
    background: rgba(231, 111, 81, 1);

    .water_wave_front {
      fill: rgba(231, 111, 81, 1);
    }

    .water_wave_back {
      fill: rgba(231, 111, 81, 0.2);
    }
  }

  .water-level-4 {
    @extend .water;
    background: rgba(30, 214, 255, 1);

    .water_wave_front {
      fill: rgba(30, 214, 255, 1);
    }

    .water_wave_back {
      fill: rgba(30, 214, 255, 0.2);
    }
  }

  .water-level-5 {
    @extend .water;
    background: rgba(42, 157, 143, 1);

    .water_wave_front {
      fill: rgba(42, 157, 143, 1);
    }

    .water_wave_back {
      fill: rgba(42, 157, 143, 0.2);
    }
  }

  .water-level-6 {
    @extend .water;
    background: rgba(30, 214, 255, 1);

    .water_wave_front {
      fill: rgba(30, 214, 255, 1);
    }

    .water_wave_back {
      fill: rgba(30, 214, 255, 0.2);
    }
  }

  .water-level-7 {
    @extend .water;
    background: rgba(90, 63, 255, 1);

    .water_wave_front {
      fill: rgba(90, 63, 255, 1);
    }

    .water_wave_back {
      fill: rgba(90, 63, 255, 0.2);
    }
  }

  @keyframes wave-front {
    100% {
      transform: translate(-50%, 0);
    }
  }

  @keyframes wave-back {
    100% {
      transform: translate(50%, 0);
    }
  }
}

@media (max-width: 992px) {
  .box {
    transform: translate(0, -30%);
  }
}

</style>